import React from 'react';
import { EmptyState, ExportBtn, PeriodNote, SearchBox, Section, StatusBadge } from './PosBits';
import { PosTable } from './PosTable';
import { inr, monthLabel, num, usePaged } from './posUtils';

const COLS = [
  { key: 'customer_id', label: 'Customer ID' },
  { key: 'name', label: 'Name', render: (v) => <b>{v}</b> },
  { key: 'mobile', label: 'Mobile', sortable: false },
  { key: 'status', label: 'Status', render: (v) => <StatusBadge s={v} /> },
  { key: 'total_orders', label: 'Orders', align: 'right', render: num },
  { key: 'total_sales', label: 'Sales', align: 'right', render: inr },
  { key: 'points_earned', label: 'Pts Earned', align: 'right', render: num },
  { key: 'points_burned', label: 'Pts Burned', align: 'right', render: num },
  { key: 'net_points', label: 'Net Pts', align: 'right', render: num },
  { key: 'first_month', label: 'First Purchase', render: monthLabel },
  { key: 'last_month', label: 'Last Purchase', render: monthLabel },
  { key: 'active_months', label: 'Active Months', align: 'right' },
  { key: 'avg_monthly_sales', label: 'Avg Monthly Sales', align: 'right', render: inr },
];

export const CustomersTab = ({ params, openCustomer }) => {
  const t = usePaged('customers', params, 'total_sales');
  const d = t.data;
  if (d?.empty) return <EmptyState />;
  return (
    <Section title="Customer Details" testid="customers-tab"
      right={<div className="flex gap-2"><SearchBox value={t.search} onChange={t.setSearch} testid="customers-search" /><ExportBtn section="customers" params={params} /></div>}>
      <div className="mb-2"><PeriodNote data={d} /></div>
      <PosTable columns={COLS} rows={d?.items} sort={t.sort} order={t.order} onSort={t.onSort} page={t.page} total={d?.total}
        onPage={t.setPage} loading={t.loading} testid="customers-table" onRowClick={(r) => openCustomer(r.customer_id)} />
      <p className="text-[11px] text-slate-500 mt-2">Totals cover the selected period. Click a customer to see the full month-by-month history. Customer ID is the unique key.</p>
    </Section>
  );
};
